import { all, call, put, select } from 'redux-saga/effects';

import { apiRequest } from '../../api/api.saga-services';
import * as api from '../../api/request-config/payment.api';
import { paymentSelectors } from './payment.selectors';

import * as actions from './payment.actions';
import * as types from './payment.types';

const normalizePayment = (payment: types.IPayment): types.IPayment => ({
  ...payment,
  id: String(payment.id),
});

export function* storePayment(payment: types.IPayment) {
  yield put(actions.storePayment(payment));
  return payment;
}

export function* clearPayment(paymentId: types.IPayment['id']) {
  yield put(actions.clearPayment(paymentId));
}

export function* clearAllPayments() {
  const paymentIds: types.IPayment['id'][] = yield select(paymentSelectors.selectResourceIds);
  yield put(actions.clearPayment(paymentIds));
}

export function* getPayments() {
  const payments = (yield call(apiRequest, api.getPaymentsApi())) as types.IPayment[] | null;
  if (!payments) {
    return;
  }

  yield call(clearAllPayments);
  const normalized = payments.map(normalizePayment);
  yield all(normalized.map((payment) => call(storePayment, payment)));
  return normalized;
}
